import { css } from 'glamor';
import * as theme from '../../../theme';

/* Shared type scale for the bay-access surfaces, ported from Nick's preview
 * design (DRI-2874) so the New Booking bay picker matches it visually. */
export const TYPE_SCALE = {
	sectionHeading: { fontSize: 18, fontWeight: 600, lineHeight: 1.3 },
	subheading: { fontSize: 15, fontWeight: 600, lineHeight: 1.3 },
	control: { fontSize: 14, fontWeight: 400, lineHeight: 1.45 },
	emphasis: { fontSize: 14, fontWeight: 500, lineHeight: 1.45 },
	metadata: { fontSize: 12, fontWeight: 400, lineHeight: 1.4 },
};

export const TYPOGRAPHY = {
	emphasis: css({ ...TYPE_SCALE.emphasis, color: theme.gray90 }),
	metadata: css({ ...TYPE_SCALE.metadata, color: theme.gray50 }),
	muted: css({ ...TYPE_SCALE.control, color: theme.gray50 }),
};
